export enum EnCrud {
    create = 'create',
    read = 'read',
    update = 'update',
    delete = 'delete'
}
